/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Footer_ProjectInputs */

const en_gc_footer_project = /** @type {(inputs: Gc_Footer_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The project`)
};

const zh_gc_footer_project = /** @type {(inputs: Gc_Footer_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`开源项目`)
};

/**
* | output |
* | --- |
* | "The project" |
*
* @param {Gc_Footer_ProjectInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_footer_project = /** @type {((inputs?: Gc_Footer_ProjectInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Footer_ProjectInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_footer_project(inputs)
	return zh_gc_footer_project(inputs)
});
export { gc_footer_project as "gc.footer.project" }